import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/familjen-grotesk';
import '@fontsource-variable/manrope';
import App from './App';
import './styles.css';
import './commerce.css';
import './pricing-interactions.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
